import { useCalendarDetailsController } from './calendar-details-page.controller';
import { BookingPlannerView } from './components/booking-planner/booking-planner.view';
import CalendarWeekView from './components/calendar-week-view/calendar-week-view.view';
import { MonthView } from './components/month-view/month-view.view';

export default function CalendarDetailsPage() {
	const { viewMode } = useCalendarDetailsController();

	switch (viewMode) {
		case 'month':
			return <MonthView />;
		case 'planner':
			return <BookingPlannerView />;
		case 'week':
			return <CalendarWeekView />;
		default:
			return <BookingPlannerView />;
	}
}
